import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/Login-img.png'

const ResetPassword = () => {
    const [step, setStep] = useState(1); // Track current step
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const otpRefs = useRef([]);
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [load1, setLoad1] = useState(false);
    const [load2, setLoad2] = useState(false);
    const url = API_BASE_URL
    const [timer, setTimer] = useState(30); // 3 minutes in seconds
    const [resendCooldown, setResendCooldown] = useState(180); // increase with each resend
    const [resendCount, setResendCount] = useState(1); // tracks how many times user clicked resend
    const [loadresend, setLoadResend] = useState(false)

    // Handle email submission
    const handleEmailSubmit = async (e) => {
        setLoad(true)
        e.preventDefault();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            toast.error('Please enter a valid email address.');
            return;
        }
        try {
            const response = await fetch(`${url}/login/request-password-reset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email })
            })
            const res = await response.json();
            if (response.ok) {
                toast.success("OTP sent to your email", {
                    position: "top-center",
                    autoClose: 3000
                });
                setStep(2);
            } else {
                toast.error(res.message || "Failed to send OTP", {
                    position: "top-center",
                    autoClose: 3000
                });
            }
            setLoad(false)
        } catch (error) {
            console.error(error);
            toast.warning(error, {
                position: "top-center",
                autoClose: 3000
            })
            setLoad(false)
        }
        // Simulate sending OTP to the email

    };

    // Handle OTP input
    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Move to the next input automatically
            if (value && index < otp.length - 1) {
                otpRefs.current[index + 1].focus();
            }
        }
    };

    // Verify OTP
    const handleVerifyOtp = async () => {
        const otpString = otp.join('');
        if (otpString.length === 6) {
            setLoad1(true);
            try {
                const response = await fetch(`${url}/login/verify-otp`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ email, otp: otpString })
                });

                const data = await response.json();  // 🛑 Important: Parse JSON here

                if (response.ok) {
                    toast.success('OTP verified successfully!', {
                        position: "top-center",
                        autoClose: 3000
                    });
                    setLoad1(false)
                    setStep(3);
                } else {
                    toast.warning(data.message || "Something went wrong", {   // ✅ use `data.message`
                        position: "top-center",
                        autoClose: 3000
                    });
                    setLoad1(false)
                }
            } catch (error) {
                toast.error("Network error. Please try again later.", {   // ✅ Improve error
                    position: "top-center",
                    autoClose: 3000
                });
                setLoad1(false)
            }
        } else {
            toast.error('Invalid OTP. Please try again.');
            setLoad1(false)
        }
    };


    // Handle password reset
    const handlePasswordReset = async (e) => {
        e.preventDefault();

        if (password.length < 6) {
            toast.error('Password must be at least 6 characters long.');
            return;
        }
        if (password !== confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }
        setLoad2(true)
        try {
            const response = await fetch(`${url}/login/new-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email,
                    newPassword: password
                })
            })
            const res = await response.json();
            if (response.ok) {

                navigate("/login")
                toast.success('Password reset successfully!', {
                    position: "top-center",
                    autoClose: 3000
                });
                setLoad2(false)
            } else {
                toast.error(res.message || "Failed to reset password", {
                    position: "top-center",
                    autoClose: 3000
                });
                setLoad2(false)
            }
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 3000
            })
            setLoad2(false)
        }

        // Redirect or perform further actions
    };

    const handleResendOtp = async () => {
        setLoadResend(true);
        try {
            const response = await fetch(`${url}/login/request-password-reset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email })
            });

            const res = await response.json();
            if (response.ok) {
                toast.success("OTP resent to your email");
                setResendCount((prev) => prev + 1);
                const newCooldown = 180 * (resendCount + 1); // 3 min, 6 min, 9 min...
                setTimer(newCooldown);
                setResendCooldown(newCooldown);
            } else {
                toast.error(res.message || "Failed to resend OTP");
            }
            setLoadResend(false);
        } catch (err) {
            console.error(err);
            toast.error("Failed to resend OTP");
            setLoadResend(false);
        } finally {
            setLoadResend(false);
        }
    };


    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, '0');
        const s = String(seconds % 60).padStart(2, '0');
        return `${m}:${s}`;
    };


    useEffect(() => {
        let interval;
        if (step === 2 && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [step, timer]);


    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="login-bg">
                <div className="login-img">
                    <img src={loginImg} alt="" />
                </div>
                <div className="login-box reset-box">
                    <h2>Reset Password</h2>
                    {step === 1 && (
                        <>
                            <form onSubmit={handleEmailSubmit}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email address"
                                    required
                                />
                                {
                                    load ? <button type="button">Loading...</button> :
                                        <button type="submit">Send OTP</button>
                                }

                                <p className="register">
                                    Already register? <Link to='/login'>Login now</Link>
                                </p>
                            </form>
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <p>Enter the 6-digit OTP sent to your email.</p>
                            <div className="otp-inputs">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        ref={(el) => (otpRefs.current[index] = el)}
                                        className="otp-input"
                                        placeholder="-"
                                    />
                                ))}
                            </div>
                            {
                                load1 ? <button >Loading...</button> :
                                    <button onClick={handleVerifyOtp}>Verify OTP</button>
                            }
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "center", marginTop: "10px" }}>
                                <span style={{ fontSize: "14px", color: "#555" }}>
                                    Time remaining: <strong>{formatTime(timer)}</strong>
                                </span>
                                {
                                    loadresend ? <span
                                        style={{
                                            fontSize: "14px",
                                            color: "#007aff",
                                            cursor: "not-allowed",
                                            fontWeight: "bold",
                                            textDecoration: "none"
                                        }}
                                    >
                                        Sending...
                                    </span> : <span
                                        style={{
                                            fontSize: "14px",
                                            color: timer === 0 ? "#007aff" : "#999",
                                            cursor: timer === 0 ? "pointer" : "not-allowed",
                                            fontWeight: "bold",
                                            textDecoration: timer === 0 ? "underline" : "none"
                                        }}
                                        onClick={timer === 0 ? handleResendOtp : null}
                                    >
                                        Resend OTP
                                    </span>
                                }
                            </div>

                            <p className="register">
                                Already register? <Link to='/login'>Login now</Link>
                            </p>
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <p>Set a new password.</p>
                            <form onSubmit={handlePasswordReset}>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="New Password"
                                    required
                                />
                                <input
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm Password"
                                    required
                                />
                                {
                                    load2 ? <button type="button">Loading...</button> :
                                        <button type="submit">Reset Password</button>
                                }
                                {/* <button type="submit">Reset Password</button> */}

                                <p className="register">
                                    Already register? <Link to='/login'>Login now</Link>
                                </p>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
